import React from "react";

interface Props {
  color?: string;
  height?: number;
  width?: number;
}

export default function StopLogoIcon(props: Props): JSX.Element {
  const { width, height, color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "386"}
      height={height || "133"}
      viewBox="0 0 470 133"
    >
      <g id="Stop" transform="translate(-193 -130)">
        <text
          id="STOP_"
          data-name="STOP!"
          transform="translate(318 238)"
          fill={color || "#c70d0a"}
          font-size="120"
          font-family="SegoeUI, Segoe UI"
          fontWeight="900"
        >
          <tspan x="0" y="0">
            STOP!
          </tspan>
        </text>
        <g id="Stop_Sign" data-name="Stop Sign" transform="translate(129 120)">
          <path
            id="Subtração_15"
            data-name="Subtração 15"
            d="M-16327.25,10144.8h-37.5l-31.251-31.187v-37.425l31.251-31.19h37.5l31.248,31.19v37.425l-31.248,31.187h0Zm-35.392-93.494a2.088,2.088,0,0,0-1.474.617l-24.965,25.236a2.107,2.107,0,0,0-.609,1.49v33.647a2.107,2.107,0,0,0,.609,1.489l24.965,25.236a2.088,2.088,0,0,0,1.474.617h33.289a2.054,2.054,0,0,0,1.469-.617l24.965-25.236a2.11,2.11,0,0,0,.609-1.489v-33.647a2.111,2.111,0,0,0-.609-1.49l-24.965-25.236a2.054,2.054,0,0,0-1.469-.617Zm32.424,84.129h-31.564l-23.747-24.007v-31.906l23.747-24.006h31.565l23.747,24.006v31.906l-23.747,24.007Zm-27.3-54.852a2.558,2.558,0,0,0-2.452,2.646c-.014,5.168-.013,14.058,0,26.421,0,4.754,3.6,8.621,8.012,8.621h10.377a7.939,7.939,0,0,0,6.991-4.407l8.975-17.237-.506-.415a.072.072,0,0,0-.013-.012l-.017-.014a3.84,3.84,0,0,0-2.644-1.045c-.095,0-.178,0-.253.008a3.957,3.957,0,0,0-2.781,1.47l-2.589,3.151a.729.729,0,0,1-.569.271.735.735,0,0,1-.253-.045.736.736,0,0,1-.49-.7l-.017-21.682a2.578,2.578,0,0,0-2.452-2.683,2.557,2.557,0,0,0-2.452,2.58c0,1.076,0,2.2,0,3.332v.027c0,1.163,0,2.336,0,3.479v10a.719.719,0,0,1-.214.522.76.76,0,0,1-.522.214.764.764,0,0,1-.526-.214.724.724,0,0,1-.218-.519v-21.689a2.776,2.776,0,0,0-.787-1.959,2.343,2.343,0,0,0-1.666-.707h-.074a2.578,2.578,0,0,0-2.477,2.662v21.693a.744.744,0,0,1-.741.745.743.743,0,0,1-.74-.745v-18.892a2.569,2.569,0,0,0-2.432-2.683,2.571,2.571,0,0,0-2.437,2.683v18.892a.743.743,0,0,1-.74.745.744.744,0,0,1-.741-.745v-11.135a2.566,2.566,0,0,0-2.48-2.638Z"
            transform="translate(16460 -10021)"
            fill={color || "#c70d0a"}
          />
        </g>
      </g>
    </svg>
  );
}
